<template>
  <div class="dashboard-container">
    <!-- 登录信息卡片 -->
    <el-card class="user-info-card">
      <div class="user-info-content">
        <div class="user-avatar">
          <el-avatar :size="80" :src="userInfo.avatar">
            {{ userInfo.name ? userInfo.name.charAt(0) : 'U' }}
          </el-avatar>
        </div>
        <div class="user-details">
          <h3>{{ userInfo.name || '用户' }}</h3>
          <p>用户名: {{ userInfo.username || '未知' }}</p>
          <p>角色: {{ userInfo.roles ? userInfo.roles.join(', ') : '普通用户' }}</p>
          <p>登录时间: {{ currentTime }}</p>
        </div>
        <div class="user-stats">
          <div class="stat-item">
            <div class="stat-number-red">{{ systemStats.loginCount }}</div>
            <div class="stat-label">代办事项</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ systemStats.operationCount }}</div>
            <div class="stat-label">操作次数</div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 统计栏目 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon user-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ systemStats.totalUsers }}</div>
              <div class="stat-label">总用户数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon role-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ systemStats.totalRoles }}</div>
              <div class="stat-label">角色数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon member-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ systemStats.totalMembers }}</div>
              <div class="stat-label">会员数</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-content">
            <div class="stat-icon menu-icon">
              <i class="el-icon-menu"></i>
            </div>
            <div class="stat-info">
              <div class="stat-number">{{ systemStats.totalMenus }}</div>
              <div class="stat-label">菜单数</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
<!-- 左侧快捷操作菜单 -->
    <!--<el-row :gutter="20" class="main-content">
      
      <el-col :span="12">
        <el-card class="quick-actions-card">
          <template #header>
            <div class="card-header">
              <span>快捷操作</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8" v-for="action in quickActions" :key="action.id">
              <div class="quick-action-item" @click="handleQuickAction(action)">
                <div class="action-icon">
                  <i :class="action.icon"></i>
                </div>
                <div class="action-label">{{ action.label }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      
      <el-col :span="12">
        <el-card class="notifications-card">
          <template #header>
            <div class="card-header">
              <span>最新通知</span>
              <el-button type="text">查看更多</el-button>
            </div>
          </template>
          <div class="notifications-list">
            <div
              v-for="notification in notifications"
              :key="notification.id"
              class="notification-item"
            >
              <div class="notification-icon">
                <i :class="notification.icon"></i>
              </div>
              <div class="notification-content">
                <div class="notification-title">{{ notification.title }}</div>
                <div class="notification-time">{{ notification.time }}</div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>--><!-- 右侧通知列表 -->

    <!-- 日志显示 -->
    <el-card class="logs-card">
      <template #header>
        <div class="card-header">
          <span>系统日志</span>
          <el-button type="text">查看全部</el-button>
        </div>
      </template>
      <el-table :data="logs" style="width: 100%">
        <el-table-column prop="time" label="时间" width="180"></el-table-column>
        <el-table-column prop="user" label="用户" width="120"></el-table-column>
        <el-table-column prop="action" label="操作"></el-table-column>
        <el-table-column prop="ip" label="IP地址" width="140"></el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.status === '成功' ? 'success' : 'danger'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { logAPI, statsAPI, memberAPI } from '@/services/api.js'

export default {
  name: 'Dashboard',
  data() {
    return {
      currentTime: new Date().toLocaleString('zh-CN'),
      // 统计数据
      systemStats: {
        totalUsers: 0,
        totalRoles: 0,
        totalMembers: 0,
        totalMenus: 0,
        loginCount: 0,
        operationCount: 0
      },
      quickActions: [
        { id: 1, label: '添加用户', icon: 'el-icon-user', path: '/user-management' },
        { id: 2, label: '角色管理', icon: 'el-icon-s-custom', path: '/role-management' },
        { id: 3, label: '权限设置', icon: 'el-icon-lock', path: '/permission-management' },
        { id: 4, label: '菜单配置', icon: 'el-icon-menu', path: '/menu-management' },
        { id: 5, label: '数据统计', icon: 'el-icon-data-analysis', path: '/dashboard' },
        { id: 6, label: '系统设置', icon: 'el-icon-setting', path: '/system' }
      ],
      notifications: [
        { id: 1, title: '系统更新通知：版本v2.1.0已发布', icon: 'el-icon-bell', time: '2分钟前' },
        { id: 2, title: '新用户注册：张三加入了系统', icon: 'el-icon-user', time: '5分钟前' },
        { id: 3, title: '安全提醒：请及时修改密码', icon: 'el-icon-warning', time: '10分钟前' },
        { id: 4, title: '性能优化：系统响应速度提升20%', icon: 'el-icon-success', time: '1小时前' },
        { id: 5, title: '数据库备份：昨晚备份已完成', icon: 'el-icon-document', time: '2小时前' }
      ],
      logs: [] // 初始化为空数组，后续通过API获取
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    // 每秒更新当前时间
    this.timer = setInterval(() => {
      this.currentTime = new Date().toLocaleString('zh-CN')
    }, 1000)
    
    // 加载系统统计数据
    this.loadSystemStats()
    // 加载系统日志
    this.loadSystemLogs()
  },
  methods: {
    handleQuickAction(action) {
      if (action.path) {
        this.$router.push(action.path)
      }
    },
    
    // 加载系统统计数据
    async loadSystemStats() {
      try {
        // 获取系统统计数据
        const systemStatsData = await statsAPI.getSystemStats()
        
        // 获取会员统计数据
        const memberStatsData = await memberAPI.getMemberStatistics()
        
        // 更新统计数据
        if (systemStatsData) {
          this.systemStats.totalUsers = systemStatsData.totalUsers || 0
          this.systemStats.totalRoles = systemStatsData.totalRoles || 0
          this.systemStats.totalMenus = systemStatsData.totalMenus || 0
        }
        
        if (memberStatsData) {
          this.systemStats.totalMembers = memberStatsData.totalCount || 0
        }
        // 获取当前用户的登录次数和操作次数
        //this.systemStats.loginCount = this.userInfo.loginCount || 0
        this.systemStats.operationCount = this.getUserOperationCount()
        
      } catch (error) {
        console.error('获取系统统计数据失败:', error)
        // 使用默认值
        this.systemStats = {
          totalUsers: 0,
          totalRoles: 0,
          totalMembers: 0,
          totalMenus: 0,
          loginCount: 0,
          operationCount: 0
        }
      }
    },
    
    // 获取用户操作次数（需要根据实际业务实现）
    getUserOperationCount() {
      // 这里应该调用API获取用户操作次数
      // 暂时返回模拟数据
      return Math.floor(Math.random() * 50) + 10
    },
    
    // 加载系统日志
    async loadSystemLogs() {
      try {
        // 获取最近10条系统日志
        const logsData = this.userInfo.roles[0]==='admin'? await logAPI.getAdminRecentLogs(10):await logAPI.getRecentLogs(10,this.userInfo.id)
        
        // 确保logsData是数组，如果不是则使用空数组
        const logsArray = Array.isArray(logsData) ? logsData : []
        
        // 转换日志数据格式，确保与前端展示需求匹配
        // 使用 JSON 序列化再解析，消除可能的响应式干扰和循环引用
        this.logs = JSON.parse(JSON.stringify(
          logsArray.map(log => ({
            time: log.createTime ? new Date(log.createTime).toLocaleString('zh-CN') : '',
            user: log.userName ? log.userName : this.userInfo.name,
            action: log.action,
            ip: log.ipAddress,
            status: log.status
          }))
        ));
      } catch (error) {
        console.error('获取系统日志失败:', error)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 0;
}

.user-info-card {
  margin-bottom: 20px;
}

.user-info-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-avatar {
  flex-shrink: 0;
  margin-right: 20px;
}

.user-details {
  flex: 1;
}

.user-details h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.user-details p {
  margin: 5px 0;
  color: #666;
  font-size: 14px;
}

.user-stats {
  display: flex;
  gap: 30px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 5px;
}

.stat-number-red {
  font-size: 24px;
  font-weight: bold;
  color: #FF0000;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  color: #999;
}

.stats-row {
  margin-bottom: 20px;
}

.stat-card {
  border-radius: 8px;
}

.stat-content {
  display: flex;
  align-items: center;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
}

.user-icon { background: #67C23A; }
.role-icon { background: #E6A23C; }
.member-icon { background: #F56C6C; }
.menu-icon { background: #409EFF; }

.stat-info {
  flex: 1;
}

.stat-info .stat-number {
  font-size: 28px;
  margin-bottom: 5px;
}

.stat-info .stat-label {
  font-size: 14px;
  color: #909399;
}

.main-content {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quick-actions-card,
.notifications-card {
  height: 300px;
}

.quick-action-item {
  text-align: center;
  padding: 20px 0;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 8px;
}

.quick-action-item:hover {
  background: #f5f7fa;
  transform: translateY(-2px);
}

.action-icon {
  width: 50px;
  height: 50px;
  margin: 0 auto 10px;
  background: #409EFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.action-label {
  font-size: 14px;
  color: #606266;
}

.notifications-list {
  height: 240px;
  overflow-y: auto;
}

.notification-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #409EFF;
}

.notification-content {
  flex: 1;
}

.notification-title {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
}

.notification-time {
  font-size: 12px;
  color: #909399;
}

.logs-card {
  margin-bottom: 20px;
}
</style>
